<template>
    <internal>
        <tab-panel
            :panels="[
                'StudentDetails',
                'LoginDetails',
                'LastQualification',
                'Address',
                'Documents',
                'Fees',
                'AdmissionDetails',
                'Performance',
            ]"
        >
            <template #StudentDetails>
                <loading :showLoading="form.processing" />
                <p class="text-lg font-medium mb-4">Student Details</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-4 gap-4 mb-4">
                        <div class="">
                            <breeze-label :value="'First Name'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.first_name"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.first_name : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Middle Name'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.middle_name"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.middle_name : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Last Name'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.last_name"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.last_name : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Mother Name'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.mother_name"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.mother_name : ''
                                "
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Email'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.email"
                                :disabled="true"
                            />
                            <breeze-input-error
                                :message="form.errors ? form.errors.email : ''"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Mobile'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.mobile"
                            />
                            <breeze-input-error
                                :message="form.errors ? form.errors.mobile : ''"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Alternate Mobile'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.alternate_mobile"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.alternate_mobile
                                        : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Blood Group'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.blood_group"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.blood_group : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Caste Category'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.caste_category"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.caste_category
                                        : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Nationality'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.nationality"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.nationality : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Religion'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.religion"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.religion : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Mother Tongue'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.mother_tongue"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.mother_tongue : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Male'" />
                            <input-checkbox
                                value="male"
                                type="radio"
                                class="rounded-full"
                                name="gender"
                                v-model="form.gender"
                                :checked="form.gender == 'male'"
                            />
                            <breeze-input-error
                                :message="form.errors ? form.errors.gender : ''"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Female'" />
                            <input-checkbox
                                value="female"
                                type="radio"
                                class="rounded-full"
                                name="gender"
                                v-model="form.gender"
                                :checked="form.gender == 'female'"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Other'" />
                            <input-checkbox
                                value="other"
                                type="radio"
                                class="rounded-full"
                                name="gender"
                                v-model="form.gender"
                                :checked="form.gender == 'other'"
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Martial Status'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.martial_status"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.martial_status
                                        : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Adhaar No'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.adhaar_no"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.adhaar_no : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Date of Birth'" />
                            <breeze-input
                                type="date"
                                class="w-full"
                                v-model="form.date_of_birth"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.date_of_birth : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Parent Mobile'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.parent_mobile"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.parent_mobile : ''
                                "
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Parent Alternate Mobile'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.parent_alternate_mobile"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.parent_alternate_mobile
                                        : ''
                                "
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Parent Email'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.parent_email"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors ? form.errors.parent_email : ''
                                "
                            />
                        </div>
                    </div>
                    <hr class="my-2 border border-gray-300" />
                    <p class="text-lg font-medium mb-4">University Details</p>
                    <div class="grid grid-cols-4 gap-4 mb-4">
                        <div class="">
                            <breeze-label :value="'Enrollment No'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.university_registation_no"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.university_registation_no
                                        : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Roll no'" />
                            <breeze-input
                                class="w-full"
                                v-model="form.university_username"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.university_username
                                        : ''
                                "
                            />
                        </div>
                        <div class="">
                            <breeze-label :value="'Password'" />
                            <breeze-input
                                :type="passwordFieldType"
                                class="w-full"
                                v-model="form.university_password"
                            />
                            <breeze-input-error
                                :message="
                                    form.errors
                                        ? form.errors.university_password
                                        : ''
                                "
                            />
                        </div>
                        <div class="pt-6">
                            <breeze-button
                                type="button"
                                @click="switchVisibility"
                            >
                                {{
                                    passwordFieldType === "password"
                                        ? "Show"
                                        : "Hide"
                                }}
                            </breeze-button>
                        </div>
                    </div>
                    <div class="flex space-x-2">
                        <breeze-button :disabled="form.processing"
                            >Save</breeze-button
                        >
                        <UniversityFeesStatusForm />
                    </div>
                    <span
                        v-if="form.recentlySuccessful"
                        class="text-green-500 mx-4"
                        >Student Details Updated!</span
                    >
                    <exception />
                </form>
            </template>
            <template #LoginDetails>
                <loading :showLoading="loginForm.processing" />
                <p class="text-lg font-medium mb-4">Login Details</p>
                <form @submit.prevent="loginFormSubmit">
                    <div class="grid grid-cols-4 gap-4 mb-4">
                        <div class="col-span-2">
                            <breeze-label :value="'Email'" />
                            <div class="relative">
                                <breeze-input
                                    class="w-full"
                                    :type="emailFieldType"
                                    v-model="loginForm.email"
                                    @focus="onEmailFocus"
                                    @blur="onEmailBlur"
                                />
                            </div>
                            <breeze-input-error
                                :message="
                                    loginForm.errors
                                        ? loginForm.errors.email
                                        : ''
                                "
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Confirm Email'" />
                            <breeze-input
                                class="w-full"
                                type="email"
                                v-model="loginForm.confirm_email"
                            />
                            <breeze-input-error
                                :message="
                                    loginForm.errors
                                        ? loginForm.errors.confirm_email
                                        : ''
                                "
                            />
                        </div>
                    </div>

                    <div class="flex space-x-2">
                        <breeze-button :disabled="loginForm.processing"
                            >Save</breeze-button
                        >

                        <span
                            v-if="loginForm.recentlySuccessful"
                            class="text-green-500 mx-4"
                            >Login Details Updated!</span
                        >
                    </div>
                    <exception />
                </form>
            </template>
            <template #LastQualification>
                <p class="text-lg font-medium mb-4">
                    Last Qualification Details
                </p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="">
                        <breeze-label :value="'Year'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.last_qualification_year"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Percentage'" />
                        <breeze-input
                            class="w-full"
                            :value="
                                admission.student.last_qualification_percentage
                            "
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Mark'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.last_qualification_marks"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Educational Gap'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.education_gap"
                            :disabled="true"
                        />
                    </div>
                    <div>
                        <breeze-label :value="'Passed Stream'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.passed_stream"
                            :disabled="true"
                        />
                    </div>
                </div>
            </template>
            <template #Address>
                <p class="text-lg font-medium mb-4">
                    Permanent Address Details
                </p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 1'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.address_line_1"
                            :disabled="true"
                        />
                    </div>
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 2'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.address_line_2"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'City'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.city"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'State'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.state"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Pincode'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.pincode"
                            :disabled="true"
                        />
                    </div>
                </div>
                <hr class="my-2 border border-gray-300" />
                <p class="text-lg font-medium mb-4">
                    Temporary Address Details
                </p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 1'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.temp_address_line_1"
                            :disabled="true"
                        />
                    </div>
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 2'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.temp_address_line_2"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'City'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.temp_city"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'State'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.temp_state"
                            :disabled="true"
                        />
                    </div>
                    <div class="">
                        <breeze-label :value="'Pincode'" />
                        <breeze-input
                            class="w-full"
                            :value="admission.student.temp_pincode"
                            :disabled="true"
                        />
                    </div>
                </div>
            </template>
            <template #Documents>
                <p class="text-lg font-medium mb-4">Student Documents</p>
                <loading :showLoading="documentForm.processing || documentDeleteForm.processing" />
                <form @submit.prevent="submitDocumentForm" class="mb-6">
                    <div class="grid grid-cols-1 md:grid-cols-12 gap-4 mb-4 items-end">
                        <div :class="documentForm.type === '__new__' ? 'md:col-span-3' : 'md:col-span-4'">
                            <breeze-label :value="'Type'" />
                            <select
                                class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2 w-full h-10"
                                :class="{
                                    'bg-white cursor-pointer': canUpdate,
                                    'bg-gray-100 cursor-not-allowed': !canUpdate,
                                }"
                                v-model="documentForm.type"
                                :disabled="!canUpdate"
                            >
                                <option value="">Select Type</option>
                                <option
                                    v-for="type in availableDocumentTypes"
                                    :key="type"
                                    :value="type"
                                >
                                    {{ type }}
                                </option>
                                <option value="__new__">New Type</option>
                            </select>
                            <breeze-input-error
                                :message="documentForm.errors ? documentForm.errors.type : ''"
                            />
                        </div>
                        <div class="md:col-span-3" v-if="documentForm.type === '__new__'">
                            <breeze-label :value="'New Type'" />
                            <breeze-input
                                class="w-full h-10"
                                v-model="documentForm.new_type"
                                :disabled="!canUpdate"
                            />
                            <breeze-input-error
                                :message="documentForm.errors ? documentForm.errors.new_type : ''"
                            />
                        </div>
                        <div :class="documentForm.type === '__new__' ? 'md:col-span-4' : 'md:col-span-6'">
                            <breeze-label :value="'File'" />
                            <input
                                ref="documentFileInput"
                                type="file"
                                class="sr-only"
                                accept=".pdf,.jpg,.jpeg,.png,image/jpeg,image/png,application/pdf"
                                :disabled="!canUpdate"
                                @change="handleDocumentFileChange"
                            />
                            <button
                                type="button"
                                class="mt-1 flex h-10 w-full items-center overflow-hidden rounded-md border border-gray-300 bg-white text-left shadow-sm transition focus:outline-none focus:ring focus:ring-indigo-200 disabled:cursor-not-allowed disabled:bg-gray-100"
                                :class="{
                                    'cursor-pointer hover:border-indigo-400': canUpdate,
                                    'cursor-not-allowed bg-gray-100': !canUpdate,
                                }"
                                :disabled="!canUpdate"
                                @click="$refs.documentFileInput.click()"
                            >
                                <span class="flex h-full w-11 shrink-0 items-center justify-center border-r border-gray-300 bg-gray-50 text-gray-500">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.586-6.586a4 4 0 00-5.657-5.657L5.757 10.757a6 6 0 108.486 8.486L20.5 13"
                                        />
                                    </svg>
                                </span>
                                <span class="min-w-0 flex-1 truncate px-3 text-sm text-gray-700">
                                    {{ documentFileName }}
                                </span>
                                <span class="shrink-0 border-l border-gray-300 px-3 text-xs font-semibold uppercase tracking-widest text-gray-600">
                                    Browse
                                </span>
                            </button>
                            <breeze-input-error
                                :message="documentForm.errors ? documentForm.errors.file : ''"
                            />
                        </div>
                        <div class="md:col-span-2">
                            <breeze-button
                                class="w-full h-10 justify-center"
                                :disabled="documentForm.processing || !canUpdate"
                            >
                                Upload
                            </breeze-button>
                        </div>
                    </div>
                    <span
                        v-if="documentForm.recentlySuccessful"
                        class="text-green-500"
                        >Document Uploaded!</span
                    >
                    <exception />
                </form>
                <div class="grid grid-cols-8 gap-4 mb-4">
                    <div
                        class="col-span-2 flex items-center gap-2"
                        v-for="doc in admission.student.documents"
                        :key="doc.id"
                    >
                        <a
                            class="min-w-0 flex-1 inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 justify-center truncate"
                            :href="doc.file"
                            target="_blank"
                            >{{ doc.title }}</a
                        >
                        <button
                            type="button"
                            class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-transparent bg-red-600 text-white hover:bg-red-700 focus:outline-none focus:border-red-700 focus:ring focus:ring-red-200 active:bg-red-800 disabled:cursor-not-allowed disabled:bg-red-300 transition ease-in-out duration-150"
                            :disabled="documentDeleteForm.processing || !canUpdate"
                            :aria-label="`Delete ${doc.title}`"
                            title="Delete"
                            @click="deleteDocument(doc)"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3m-8 0h10"
                                />
                            </svg>
                        </button>
                    </div>
                    <p
                        class="text-red-500 font-medium col-span-3"
                        v-if="!admission.student.documents.length"
                    >
                        Documents not uploaded by student.
                    </p>
                </div>
            </template>

            <template #Fees>
                <EmiStructure />
            </template>

            <template #AdmissionDetails>
                <form @submit.prevent="admissionFormSubmit">
                    <p class="text-lg font-medium mb-4">Admission Details</p>
                    <div class="grid grid-cols-4 gap-4 mb-4">
                        <div class="col-span-2">
                            <breeze-label :value="'Academic Year'" />
                            <breeze-input
                                class="w-full"
                                :value="
                                    admission.academicyear.start_month +
                                    ' - ' +
                                    admission.academicyear.end_month
                                "
                                :disabled="true"
                            />
                        </div>

                        <div class="col-span-2">
                            <FormMultiselect
                                :disabled="!canUpdate"
                                @change="
                                    () => {
                                        admissionForm.course_year_id = '';
                                        admissionForm.batch_id = '';
                                    }
                                "
                                :required="true"
                                label="Course"
                                :options="courses"
                                track-key="title"
                                label-key="title"
                                :object="false"
                                v-model="admissionForm.course_id"
                                :error="admissionForm.errors.course_id"
                                returnValue="id"
                                placeholder="Select Course"
                            />
                        </div>
                        <div class="col-span-2">
                            <FormMultiselect
                                :disabled="!canUpdate"
                                @change="admissionForm.batch_id = ''"
                                :required="true"
                                label="Course Year"
                                :options="years"
                                track-key="title"
                                label-key="title"
                                :object="false"
                                v-model="admissionForm.course_year_id"
                                :error="admissionForm.errors.course_year_id"
                                returnValue="id"
                                placeholder="Select Course year"
                            />
                        </div>
                        <div class="col-span-2">
                            <FormMultiselect
                                :disabled="!canUpdate"
                                :required="true"
                                label="Batch"
                                :options="batches_options"
                                track-key="title"
                                label-key="title"
                                :object="false"
                                v-model="admissionForm.batch_id"
                                :error="admissionForm.errors.batch_id"
                                returnValue="id"
                                placeholder="Select Batch"
                            />
                        </div>

                        <div class="col-span-2">
                            <div class="flex justify-between">
                                <breeze-label :value="'Roll No'" />
                                <label
                                    class="flex cursor-pointer items-center gap-2 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
                                >
                                    Please check if you want to update roll no.
                                    <input
                                        :disabled="!canUpdate"
                                        type="checkbox"
                                        class="rounded border-gray-300 cursor-pointer text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                        :checked="
                                            admissionForm.is_update_roll_no
                                        "
                                        v-model="
                                            admissionForm.is_update_roll_no
                                        "
                                /></label>
                            </div>
                            <breeze-input
                                class="w-full"
                                :value="admission.roll_no"
                                :disabled="true"
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Status'" />
                            <breeze-input
                                class="w-full"
                                :value="admission.status.toUpperCase()"
                                :disabled="true"
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Date'" />
                            <breeze-input
                                class="w-full"
                                :value="convertDateTime(admission.created_at)"
                                :disabled="true"
                            />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Confirmed By'" />
                            <breeze-input
                                class="w-full"
                                :value="
                                    capitalize(
                                        admission.confirmed_by
                                            ? admission.confirmed_by.name
                                            : ''
                                    )
                                "
                                :disabled="true"
                            />
                        </div>
                        <div class="col-span-4">
                            <breeze-button
                                :disabled="
                                    admissionForm.processing || !canUpdate
                                "
                                >Save</breeze-button
                            >
                            <span
                                v-if="admissionForm.recentlySuccessful"
                                class="text-green-500 mx-4"
                                >Admission Details Updated!</span
                            >
                            <exception />
                        </div>
                    </div>
                </form>
                <form @submit.prevent="submitPartialForm">
                    <div class="grid grid-cols-8 gap-4 mb-4 border-t pt-4">
                        <div class="col-span-full">
                            <div class="flex space-x-2 items-center">
                                <breeze-checkbox
                                    v-model="partialForm.partial_approval"
                                    :checked="partialForm.partial_approval"
                                />
                                <breeze-label :value="'Partial Approval'" />
                            </div>

                            <breeze-input-error
                                :message="
                                    partialForm.errors
                                        ? partialForm.errors.partial_approval
                                        : ''
                                "
                            />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <div v-if="partialForm.partial_approval">
                                <breeze-label class="mb-1" :value="'Note'" />
                                <textarea
                                    rows="3"
                                    v-model="partialForm.notes"
                                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border border-gray-300 rounded-md px-4 py-2 w-full"
                                ></textarea>
                                <breeze-input-error
                                    :message="
                                        partialForm.errors
                                            ? partialForm.errors.notes
                                            : ''
                                    "
                                />
                            </div>
                        </div>
                        <div class="col-span-full">
                            <breeze-button :disabled="partialForm.processing"
                                >Save</breeze-button
                            >
                            <span
                                v-if="partialForm.recentlySuccessful"
                                class="text-green-500 mx-4"
                                >Admission Details Updated!</span
                            >
                            <exception />
                        </div>
                    </div>
                </form>
            </template>
            <template #Performance>
                <div>
                    <div class="flex justify-between">
                        <h2>Performance Overview</h2>
                        <v-date-picker
                            v-model="selectedDateRange"
                            is-range
                            :modelConfig="modelConfig"
                            :masks="masks"
                        >
                            <template v-slot="{ inputValue, togglePopover }">
                                <div class="flex items-center">
                                    <button
                                        class="p-2 bg-blue-100 border border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                                        @click="togglePopover()"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            class="w-4 h-4 fill-current"
                                        >
                                            <path
                                                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
                                            ></path>
                                        </svg>
                                    </button>
                                    <input
                                        :value="
                                            inputValue.start +
                                            '-' +
                                            inputValue.end
                                        "
                                        class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                                        disabled
                                    />
                                </div>
                            </template>
                        </v-date-picker>
                    </div>
                    <div class="flex flex-wrap">
                        <template v-if="!loadingSubmissions">
                            <div
                                class="min-w-0 rounded-lg shadow-xs overflow-hidden bg-gray-100 w-1/5 m-4"
                                v-for="(sb, index) in submissions"
                                :key="index"
                            >
                                <PerformanceStatus
                                    :name="index"
                                    :value="sb"
                                    :admission="admission"
                                    :branch-id="branchid"
                                />
                                <!--                                <div class="p-4 flex items-center">-->

                                <!--                                    <inertia-link v-if="['presentation','assignment','bonus','viva'].includes(index)" :href="route(`internal.admission.view.${index}`)">-->
                                <!--                                        <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">-->
                                <!--                                            {{ capitalize(index) }}-->
                                <!--                                        </p>-->
                                <!--                                        <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">-->
                                <!--                                            {{ sb }}%-->
                                <!--                                        </p>-->
                                <!--                                    </inertia-link>-->
                                <!--                                    <div v-else>-->
                                <!--                                        <p class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">-->
                                <!--                                            {{ capitalize(index) }}-->
                                <!--                                        </p>-->
                                <!--                                        <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">-->
                                <!--                                            {{ sb }}%-->
                                <!--                                        </p>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                            </div>
                        </template>
                        <template v-else>
                            <div
                                class="flex h-20 justify-center items-center w-full"
                            >
                                <div>Loading...</div>
                            </div>
                        </template>
                    </div>
                    <h2 class="mt-5">Attendance Overview</h2>
                    <div class="flex flex-col mb-8">
                        <template v-if="!loadingSubmissions">
                            <div
                                class="flex items-center justify-end space-x-8 text-base mt-5"
                            >
                                <div class="flex flex-row space-x-2 py-2">
                                    <div
                                        class="w-6 h-6 flex items-end justify-center"
                                    >
                                        <span
                                            class="w-1.5 h-1.5 rounded-full"
                                            style="background: #3182ce"
                                        ></span>
                                    </div>
                                    <div>Present</div>
                                </div>
                                <div class="flex flex-row space-x-2 py-2">
                                    <div
                                        class="w-6 h-6 rounded-full"
                                        style="border: 2px solid #c53030"
                                    ></div>
                                    <div>Absent</div>
                                </div>
                                <div class="flex flex-row space-x-2 py-2">
                                    <div
                                        class="w-6 h-6 rounded-full"
                                        style="background: #bee3f8"
                                    ></div>
                                    <div>Holiday</div>
                                </div>
                            </div>
                            <v-calendar :attributes="attrs" is-expanded />
                        </template>
                        <template v-else>
                            <div
                                class="flex h-20 justify-center items-center w-full"
                            >
                                <div>Loading...</div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </tab-panel>
    </internal>
    <model :isOpen="showModel" @close="showModel = false">
        <template #body>
            <div class="grid grid-cols-6 gap-4 mb-4 items-end w-full">
                <div class="col-span-4">
                    <breeze-label :value="'Remark'" />
                    <breeze-input class="w-full" v-model="remark" />
                </div>
                <div class="col-span-2">
                    <breeze-button
                        class="mr-2"
                        @click.prevent="receiptAction('confirm')"
                        >Confirm</breeze-button
                    >
                    <breeze-button
                        class="bg-red-500"
                        @click.prevent="receiptAction('reject')"
                        >Reject</breeze-button
                    >
                </div>
            </div>
        </template>
    </model>
</template>

<script>
import Internal from "@/Pages/Internal/Internal";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeCheckbox from "@/Components/Checkbox";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import ButtonLink from "@/Components/ButtonLink";
import SelectList from "@/Components/SelectList";
import Exception from "@/Components/Exception";
import { useForm } from "@inertiajs/inertia-vue3";
import Loading from "@/Components/Loading";
import TabPanel from "@/Components/TabPanel";
import BreezeTable from "@/Components/Table";
import InputCheckbox from "@/Components/InputCheckbox";
import Model from "@/Components/Model";
import Select from "@/Components/Select";
import EmiStructure from "@/Pages/Internal/Admission/EmiStructure.vue";
import { dateField, inputDateFormat } from "../../../../Utils/Common";
import UniversityFeesStatusForm from "@/Pages/Internal/Admission/UniversityFeesStatusForm.vue";
import NavLink from "@/Components/NavLink.vue";
import PerformanceStatus from "@/Pages/Internal/Admission/PerformanceStatus.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import { hasRole } from "../../../../Utils/checkPermission";

export default {
    components: {
        FormMultiselect,
        PerformanceStatus,
        NavLink,
        UniversityFeesStatusForm,
        EmiStructure,
        Select,
        Internal,
        ButtonLink,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        SelectList,
        Exception,
        Loading,
        BreezeCheckbox,
        TabPanel,
        BreezeTable,
        InputCheckbox,
        Model,
    },
    props: [
        "admission",
        "fees",
        "branch",
        "batches",
        "admissionFees",
        "courses",
        "documentTypes",
    ],
    data() {
        return {
            admissionForm: useForm({
                course_id: this.admission.course_id,
                course_year_id: this.admission.course_year_id,
                batch_id: this.admission.batch_id,
                is_update_roll_no: false,
            }),
            form: useForm({
                _method: "PUT",
                first_name: this.admission.student.first_name,
                middle_name: this.admission.student.middle_name,
                last_name: this.admission.student.last_name,
                email: this.admission.student.email,
                mother_name: this.admission.student.mother_name,
                mobile: this.admission.student.mobile,
                alternate_mobile: this.admission.student.alternate_mobile,
                blood_group: this.admission.student.blood_group,
                caste_category: this.admission.student.caste_category,
                nationality: this.admission.student.nationality,
                religion: this.admission.student.religion,
                mother_tongue: this.admission.student.mother_tongue,
                gender: this.admission.student.gender,
                martial_status: this.admission.student.martial_status,
                adhaar_no: this.admission.student.adhaar_no,
                date_of_birth: this.admission.student.date_of_birth,
                parent_mobile: this.admission.student.parent_mobile,
                parent_alternate_mobile:
                    this.admission.student.parent_alternate_mobile,
                parent_email: this.admission.student.parent_email,
                university_registation_no:
                    this.admission.student.university_registation_no,
                university_username: this.admission.student.university_username,
                university_password: this.admission.student.university_password,
            }),
            partialForm: useForm({
                _method: "PUT",
                partial_approval: !!this.admission.partial_approval,
                notes: this.admission.notes,
            }),
            loginForm: useForm({
                _method: "POST",
                email: this.admission.student.email,
                confirm_email: this.admission.student.email,
            }),
            documentForm: useForm({
                type: "",
                new_type: "",
                file: null,
            }),
            documentDeleteForm: useForm({}),
            // Email masking properties
            isEmailFocused: false,
            originalEmail: "",
            emailFieldType: "email",
            fields: [
                { key: "particulars", label: "Particulars" },
                {
                    key: "amount",
                    label: "Amount",
                },
                { key: "date", label: "End / Paid Date" },
                { key: "receipt", label: "Receipt No" },
                {
                    key: "status",
                    label: "Status",
                },
                { key: "action", label: "Action" },
            ],

            admissionFeesFields: [
                { key: "title", label: "Title" },
                { key: "amount", label: "Amount" },
                { key: "end_date", label: "End / Paid Date" },
                { key: "status", label: "Status" },
                { key: "action", label: "Action" },
            ],
            passwordFieldType: "password",
            branchid: localStorage.branchId,
            attrs: [],
            submissions: [],
            showModel: false,
            remark: null,
            selectedFees: null,
            loadingSubmissions: false,
            selectedDateRange: {
                start:
                    new Date().getFullYear() +
                    "-" +
                    (new Date().getMonth() + 1) +
                    "-1",
                end:
                    new Date().getFullYear() +
                    "-" +
                    (new Date().getMonth() + 1) +
                    "-31",
            },
            modelConfig: {
                type: "string",
                mask: "YYYY-MM-DD", // Uses 'iso' if missing
            },
            masks: {
                input: "DD/MM/YYYY",
            },
            // attendance:{
            //     presents:[],
            //     absents:[],
            //     holidays:[]
            // }
        };
    },
    methods: {
        submitForm() {
            this.form.post(
                route("internal.admission.student.update", [
                    this.branch.id,
                    this.admission.id,
                ])
            );
        },
        admissionFormSubmit() {
            this.admissionForm.post(
                route("internal.admission.details.update", [
                    this.admission.student.id,
                    this.admission.id,
                ])
            );
        },

        switchVisibility() {
            this.passwordFieldType =
                this.passwordFieldType === "password" ? "text" : "password";
        },
        getSubmissions() {
            let query =
                "?start=" +
                inputDateFormat(this.selectedDateRange.start) +
                "&end=" +
                inputDateFormat(this.selectedDateRange.end);
            this.loadingSubmissions = true;
            this.attrs = [];
            window.axios
                .get(
                    route("internal.admission.submissions", [
                        this.branchid,
                        this.admission.id,
                    ]) + query
                )
                .then(async (res) => {
                    let data = await res.data;
                    this.submissions = data["overview"];
                    data["attendance"]["present"].forEach((pr) => {
                        this.attrs.push({
                            key: pr.id,
                            dot: true,
                            dates: new Date(pr.attendance_at),
                        });
                    });
                    data["attendance"]["absent"].forEach((ab) => {
                        this.attrs.push({
                            key: ab.id,
                            highlight: {
                                color: "red",
                                fillMode: "outline",
                            },
                            dates: new Date(ab.attendance_at),
                        });
                    });
                    data["attendance"]["holidays"].forEach((hl) => {
                        this.attrs.push({
                            key: hl.id,
                            highlight: {
                                color: "blue",
                                fillMode: "light",
                            },
                            popover: {
                                label: hl.title,
                            },
                            dates: hl.to_date
                                ? {
                                      start: new Date(hl.from_date),
                                      end: new Date(hl.to_date),
                                  }
                                : new Date(hl.from_date),
                        });
                    });
                    this.loadingSubmissions = false;
                });
        },
        receiptAction(action) {
            this.$inertia
                .post(
                    route("internal.admission.students.fees", [
                        this.branchid,
                        this.admission.id,
                        this.selectedFees,
                    ]),
                    {
                        action: action,
                        remark: this.remark,
                    }
                )
                .then(() => {
                    location.reload();
                });
        },
        submitPartialForm() {
            this.partialForm.post(
                route("internal.admission.partial.update", [this.admission.id])
            );
        },
        loginFormSubmit() {
            // Restore original email before submission if it was masked
            if (
                this.originalEmail &&
                this.loginForm.email !== this.originalEmail
            ) {
                this.loginForm.email = this.originalEmail;
            }

            this.loginForm.post(
                route("internal.admission.login.update", [
                    this.branch.id,
                    this.admission.id,
                ])
            );
        },
        handleDocumentFileChange(event) {
            this.documentForm.file = event.target.files[0] ?? null;
        },
        submitDocumentForm() {
            this.documentForm.post(
                route("internal.admission.student.documents.store", [
                    this.branch.id,
                    this.admission.id,
                ]),
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.documentForm.reset();
                        if (this.$refs.documentFileInput) {
                            this.$refs.documentFileInput.value = null;
                        }
                    },
                }
            );
        },
        deleteDocument(document) {
            if (!confirm("Are you sure to delete this document?")) {
                return;
            }

            this.documentDeleteForm.delete(
                route("internal.admission.student.documents.delete", [
                    this.branch.id,
                    this.admission.id,
                    document.id,
                ]),
                {
                    preserveScroll: true,
                }
            );
        },
        // Email masking methods
        onEmailFocus() {
            this.isEmailFocused = true;
            this.emailFieldType = "email";
            // Restore original email if it was masked
            if (this.originalEmail) {
                this.loginForm.email = this.originalEmail;
            }
        },
        onEmailBlur() {
            this.isEmailFocused = false;
            // Store the original email and mask it
            if (this.loginForm.email) {
                this.originalEmail = this.loginForm.email;
                this.maskEmail();
            }
        },
        editEmail() {
            this.isEmailFocused = true;
            this.emailFieldType = "email";
            // Restore original email
            if (this.originalEmail) {
                this.loginForm.email = this.originalEmail;
            }
            // Focus the input
            this.$nextTick(() => {
                const emailInput = document.querySelector(
                    'input[type="email"]'
                );
                if (emailInput) {
                    emailInput.focus();
                }
            });
        },
        maskEmail() {
            if (this.loginForm.email) {
                const [localPart, domain] = this.loginForm.email.split("@");
                if (localPart && domain) {
                    const maskedLocal =
                        localPart.length > 2
                            ? localPart.charAt(0) +
                              "*".repeat(localPart.length - 2) +
                              localPart.charAt(localPart.length - 1)
                            : localPart;
                    this.loginForm.email = `${maskedLocal}@${domain}`;
                    this.emailFieldType = "password";
                }
            }
        },
    },
    watch: {
        selectedDateRange(v) {
            this.getSubmissions();
        },
    },

    beforeMount() {
        // this.getAttendances()
        this.getSubmissions();
    },
    computed: {
        years() {
            return (
                this.courses.find(
                    (item) => item.id === this.admissionForm.course_id
                )?.years ?? []
            );
        },
        batches_options() {
            return (
                this.years.find(
                    (item) => item.id === this.admissionForm.course_year_id
                )?.batches ?? []
            );
        },
        availableDocumentTypes() {
            const uploadedTypes = new Set(
                this.admission.student.documents.map((doc) => doc.title)
            );

            return [
                ...new Set([
                    ...(this.documentTypes ?? []),
                ]),
            ].filter((type) => type && !uploadedTypes.has(type));
        },
        documentFileName() {
            return this.documentForm.file
                ? this.documentForm.file.name
                : "Select PDF or image";
        },
        canUpdate() {
            return (
                hasRole("Edit Admission") && this.admission.status != "closed"
            );
        },
    },
    // computed:{
    //     batchOptions(){
    //         var data = [];
    //         this.batches.map((item)=>{
    //              console.log(item);
    //         })
    //         return data;
    //     }
    // }
};
</script>
<style>
.ck-editor__editable {
    height: 400px;
}

.ck-file-dialog-button {
    display: none;
}

.vc-container {
    width: 100% !important;
}
</style>
